import { Collapse } from '@mui/material';

import {
  Typography,
  Paper,
  Switches,
  CardHeader,
  MobileFriendlyOutlinedIcon,
  IconAvatar,
} from '@occc-app/design-system';
import { useConfig } from '@occc/config';

import { PaymentMethodFormValues } from './types';
import { PaymentInstrumentConstraint } from './payment-instrument/payment-instrument-constraint';
import { getSupportedPaymentInstruments } from './payment-instrument/utils';

type PaymentMethodConstraintProps = {
  values: PaymentMethodFormValues;
  isPaymentInstrumentConstraintEnabled?: boolean;
};

export const PaymentMethodConstraint = ({
  values,
  isPaymentInstrumentConstraintEnabled = true,
}: PaymentMethodConstraintProps) => {
  const supportedPaymentTypes = useConfig('supportedPaymentTypes');
  const paymentInstruments = getSupportedPaymentInstruments(supportedPaymentTypes);

  const isPaymentInstrumentConstraintShown =
    isPaymentInstrumentConstraintEnabled && paymentInstruments.length > 0;

  return (
    <Paper>
      <CardHeader
        title={<Typography variant='subtitle1'>Mobile Pay Only</Typography>}
        subheader={
          <Typography variant='body2' color='textSecondary'>
            Members must transact through Mobile Pay to be eligible
          </Typography>
        }
        action={<Switches name='paymentMethodConstraint.isEnabled' data={{}} />}
        avatar={<IconAvatar Icon={MobileFriendlyOutlinedIcon} />}
        sx={{ py: 2, px: 3 }}
      />
      {isPaymentInstrumentConstraintShown && (
        <Collapse in={values?.paymentMethodConstraint?.isEnabled} timeout='auto' unmountOnExit>
          <PaymentInstrumentConstraint options={paymentInstruments} />
        </Collapse>
      )}
    </Paper>
  );
};
